export enum PageTypes {
  MyAccountMyListPage = "My Account - My Lists Page",
  CatalogLandingPage = "Catalog Landing Page"
}